import React from "react";
import { Container, Row, Col } from "shards-react";
import ViewFunctionSuperAdmin from "../components/function/ViewFunctionSuperAdmin";
import { toast } from "react-toastify";

class ViewfunctionPageSuperAdmin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  //this is for showing notification
  notify(type, message) {
    toast(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      type: type,
    });
  }

  render() {
    console.log('this.props', this.props);
    return (
      <Container fluid className="main-content-container px-4">
        <Row className="py-3">
          <Col lg="12">
            <ViewFunctionSuperAdmin projectId={this.props.match.params.id} notify={this.notify} />
          </Col>
        </Row>
      </Container>
    );
  }
}

export default ViewfunctionPageSuperAdmin;
